export default "__VITE_ASSET__Ba7wfAE8__"